import React, { useContext, useState } from 'react'
import BigModal from '../../../../../../components/Modals/BigModal'
import { Box, Button, Checkbox, Grid, Stack, Typography } from '@mui/material'
import SmallModal from '../../../../../../components/Modals/SmallModal'

const EmergenceActions = ({ open, onClose, submitModule }) => {
  const [checklistOptions, setCheckListOptions] = useState({
    'Stop Procedure': false,
    'Attempt Verbal Deescalation': false,
    'Consider BenzoDiazepeines': false,
    'Consider Deepening Sedation': false,
    'Continue Planned Procedure': false,
  })

  const helperTexts = {
    'Consider BenzoDiazepeines': 'Midazolam 1-2mg or Paed 0.1mg/kg',
    'Consider Deepening Sedation': 'further 0.5mg/kg dose',
    'Continue Planned Procedure': 'once plane of sedation achieved',
  }

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      style={{ width: '400px', maxWidth: '80vw' }}
    >
      <Stack overflow="auto">
        <Typography variant="title2">Emergence Actions</Typography>
        {[
          Object.keys(checklistOptions).map((option, index) => (
            <Stack
              direction="row"
              marginY={0.5}
              alignItems="center"
              onClick={(e) =>
                setCheckListOptions((prev) => ({
                  ...prev,
                  [option]: !prev[option],
                }))
              }
              sx={{ cursor: 'pointer' }}
              key={index}
            >
              <Checkbox checked={!!checklistOptions[option]} />
              <Stack>
                <Typography>{option}</Typography>
                {helperTexts[option] && (
                  <Typography variant="caption">
                    {helperTexts[option]}
                  </Typography>
                )}
              </Stack>
            </Stack>
          )),
        ]}
        <Grid xs={12} container spacing={1}>
          <Grid item xs={12} lg={4}>
            <Button
              color="error"
              onClick={() => onClose()}
              variant="contained"
              fullWidth
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Button
              color="success"
              onClick={() => {
                submitModule('Emergence Actions (Post Sedation)', {
                  ...checklistOptions,
                  isChecklist: true,
                })
                onClose()
              }}
              variant="contained"
              fullWidth
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </SmallModal>
  )
}

export default EmergenceActions
